<template>
 <div>
    <div id="main-wrapper" data-navbarbg="skin6" data-theme="light" data-layout="vertical" data-sidebartype="full" data-boxed-layout="full">
        <Header-Partial></Header-Partial>
        <div v-if="accessBilling">
            <Aside-Partial  @activarLateral="showAside = $event"></Aside-Partial>
            <div class="page-wrapper" v-bind:class="{ show: showAside }">
                <slot >                    
                </slot> 
                <footer-partial></footer-partial>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import HeaderPartial from '@/views/Header'
import AsidePartial from '@/views/Billing/Aside'
import FooterPartial from '@/views/Footer'
import Loader from '@/components/shared/Loader'
export default {
    name:'Billing',
    components:{
		HeaderPartial,
        AsidePartial,
        FooterPartial,
        Loader,
	},

    data() {
        return {
            showAside : false,
            isLoading:true,
        }
    },
    created(){
        console.log('validando sesion master', this.$store.getters.loggedIn);
        //debugger;
        if (this.$store.getters.loggedIn)
        {
            let org = localStorage.getItem('mark_client_data');
            window.master.get('getapp/'+org)
            .then(response => {
                let r = response.data.r; // listado de app disponibles 
                let AppProject = false;
                if(r.length > 0)
                {
                    for (let i in r) 
                    {
                        if(r[i].id==this.$store.getters.getAppIDactual){
                            AppProject=true;
                        }
                    }
                }
                if(AppProject)//si tiene projects asignado entonces permitir acceso
                {
                    this.$store.dispatch('validTokenBilling').then(response =>
                    {
                      //console.log(response.data);
                      if(response.data.tokenValid)
                      {
                        console.log('validTokenBilling');
                        let scopes = JSON.parse(response.data.success.scopes)
                        const accessBilling = {
                            login: response.data.tokenValid,
                            token: scopes.token,
                        };
                        this.$store.dispatch('access_billing', accessBilling);
                      }
                      else
                      {
                        this.$store.dispatch('retrieveTokenBilling', {
                          loginBIlling: true,
                        })
                        .then(response => {
                            //console.log(response.data);
                            console.log('iniciando session billing');
                        })
                        .catch((error) => {
                            //console.log(error);
                            console.log('error al iniciar sesion billing');
                            this.$router.push({ name: 'Home' });
                        });
                      }
                    });
                }
                else
                {
                    const accessBilling = {
                        login: false,
                        token: false
                    };
                    this.$store.dispatch('access_billing', accessBilling);
                    this.$router.push({ name: 'Home' });
                } //sino volver a home
            })
            .catch(error => {
                console.log(error);
            });
        }else{this.$router.push({ name: 'Home' });}
        
    },
    methods: {
    },
    watch:
    {
        showAside: function(){
            if(this.$router.currentRoute.name=='Billing' || this.$router.currentRoute.name=='Default')
            {
                this.$store.dispatch('setShowAside', this.showAside);
            }
        },
        
    },
    computed: {
        ...mapGetters({accessBilling : 'access_billing'})
    }

};

</script>
<style scoped>
    #main-wrapper[data-layout=vertical][data-sidebartype=full] .page-wrapper {
    z-index: 1;
    }
</style>
